import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a22939e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href", "fill"]




export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
  name: {
    type: String,
    required: true
  },
  size: {
    type: [Number, String],
    default: 20
  },
  height: {
    type: [Number, String],
    default: 0
  },
  color: {
    type: String,
    default: ''
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "svg-icon",
    style: _normalizeStyle({
      width: __props.size + 'px',
      height: __props.height ? __props.height : __props.size + 'px',
      color: __props.color
    })
  }, [
    _createElementVNode("use", {
      "xlink:href": `#icon-${__props.name}`,
      fill: __props.color
    }, null, 8, _hoisted_1)
  ], 4))
}
}

})